<template>
  <div>
    <span>
      <b-row>
        <b-col lg="12" sm="12">
          <vs-button
            @click="kartDetay()"
            color="primary"
            type="filled"
            size="small"
            icon="edit"
          ></vs-button>
        </b-col>
      </b-row>
    </span>
  </div>
</template>
<script>
import router from "../../../../router";

export default {
  data() {
    return {
      dir: false,
      rowDataparti: [],
    };
  },
  methods: {
    kartDetay() {
      router.push({
        path: "/finans/fatura_detay",
        query: { fisId: this.params.data },
      });
    },
  },
};
</script>
